const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/boxes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import { boxesUserPermissionsInfiniteQueryOptions } from 'src/lib/queries/common/boxes/useBoxesUserPermissionsInfiniteQuery';
import { boxesInfiniteQueryOptions } from '@/lib/queries/common/boxes/useBoxesInfiniteQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/settings/boxes/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context: {
      flags
    }
  }) => {
    if (!flags.itemStoreContainers) {
      throw notFound();
    }
  },
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureInfiniteQueryData(boxesInfiniteQueryOptions());
    await queryClient.ensureInfiniteQueryData(boxesUserPermissionsInfiniteQueryOptions());
    return {
      crumb: i18n.t('common.settings.boxes.boxes')
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t('common.settings.boxes.boxes')
    }
  }
});